import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type {
  ExternalProviderRepository,
  ExternalProviderDashboardVM,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface RetrieveExternalProviderDashboardQuery {
  externalProviderRepository: ExternalProviderRepository;
}

export const retrieveExternalProviderDashboard = createApiThunk<ExternalProviderDashboardVM, RetrieveExternalProviderDashboardQuery>(
  "externalProvider/retrieveDashboard",
  async ({ externalProviderRepository }: RetrieveExternalProviderDashboardQuery) => {
    return externalProviderRepository.getDashboard();
  },
);

export const resetRetrieveExternalProviderDashboard = createAction("externalProvider/resetRetrieveDashboard");
